export { UserPickerModule } from './user-picker.module';
export { UserPickerComponent } from './user-picker.component';